import { memo } from "react"
import {
	IconAtom2Outline18 as Atom,
	IconLockOutline18 as Lock,
} from "nucleo-ui-outline-18"

import type { ArticleVisibility } from "./article-visibility"

// Deliberately quiet: this sits on every hidden article, so it reads as chrome
// rather than an alert. The pill in the nav is where the colour goes.
// The bar spans the pane; its text lines up with the article title below it.
export const HiddenArticleBanner = memo(
	({ visibility }: { visibility: ArticleVisibility }) => {
		const isInternal = visibility === "INTERNAL"
		const Icon = isInternal ? Lock : Atom

		return (
			<div className="flex-shrink-0 border-b border-gray-200 bg-gray-50 dark:border-gray-700/80 dark:bg-gray-850">
				{/* px-6 outside the column, exactly like the article's scroll container,
			    so the text starts on the same x as the title. */}
				<div className="px-6">
					{/* 630px article column, widened by the icon + gap (12px + 8px) so the
					 *text* lands on the article's left edge rather than the icon. */}
					<div className="mx-auto flex w-full max-w-[calc(630px+0.1rem)] items-center gap-2 py-2">
						<Icon className="h-3 w-3 flex-none text-gray-500 dark:text-gray-400" />
						<p className="min-w-0 truncate text-xs text-secondary">
							{isInternal ? (
								<>
									<span className="font-medium text-primary">Internal</span> ·
									Only the AI Assistant reads this. It stays off your docs site.
								</>
							) : (
								<>
									<span className="font-medium text-primary">Agent</span> · The
									AI agent answers customers from this. It stays off your docs
									site.
								</>
							)}
						</p>
					</div>
				</div>
			</div>
		)
	},
)

HiddenArticleBanner.displayName = "HiddenArticleBanner"
